var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_175)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.7067,
    y: 8.13306,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0066 33.333C52.0066 24.4412 44.7984 17.233 35.9066 17.233C27.0149 17.233 19.8066 24.4412 19.8066 33.333C19.8066 42.2248 27.0149 49.433 35.9066 49.433C44.7984 49.433 52.0066 42.2248 52.0066 33.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9039 46.0227C43.0028 46.0227 48.7576 40.2679 48.7576 33.169C48.7576 26.0701 43.0028 20.3153 35.9039 20.3153C28.805 20.3153 23.0502 26.0701 23.0502 33.169C23.0502 40.2679 28.805 46.0227 35.9039 46.0227Z",
    stroke: "white",
    strokeWidth: 1.11771
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1869 30.0341C36.265 30.6703 35.2737 30.8883 34.2149 30.6869C33.1542 30.4867 32.3116 29.9323 31.6854 29.025L30.7537 27.675L32.0903 26.7524L33.0221 28.1025C33.3928 28.6396 33.8876 28.9652 34.5082 29.078C35.127 29.192 35.7099 29.0603 36.2533 28.6853L38.6113 27.0476C39.3608 26.5271 40.3905 26.7143 40.9088 27.4653L37.1869 30.0341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9917 34.5199C38.3543 33.5963 38.1347 32.604 38.3342 31.5447C38.5324 30.4837 39.0848 29.6416 39.9904 29.0166L41.3379 28.0865L42.2621 29.4257L40.9147 30.3557C40.3785 30.7257 40.0541 31.2203 39.9424 31.8411C39.8295 32.4602 39.9622 33.0437 40.338 33.588L41.9823 35.9557C42.5018 36.7037 42.3151 37.7315 41.5654 38.2488L38.9917 34.5199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4892 36.3336C35.4111 35.6973 36.4024 35.4793 37.4613 35.6807C38.522 35.881 39.3645 36.4353 39.9906 37.3427L40.9225 38.6927L39.5859 39.6152L38.654 38.2652C38.2834 37.728 37.7886 37.4024 37.168 37.2897C36.5491 37.1756 35.9662 37.3075 35.4228 37.6824L33.0648 39.3201C32.3153 39.8406 31.2857 39.6534 30.7673 38.9025L34.4892 36.3336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7648 31.9647C33.4023 32.8883 33.6219 33.8807 33.4224 34.9399C33.2242 36.0009 32.6717 36.8429 31.7662 37.4681L30.4187 38.398L29.4944 37.0588L30.8419 36.1289C31.378 35.7589 31.7025 35.2643 31.8141 34.6435C31.9269 34.0245 31.7943 33.4408 31.4186 32.8965L29.7743 30.5289C29.2547 29.7808 29.4416 28.7531 30.1911 28.2357L32.7648 31.9647Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_175",
    x: 0.206665,
    y: 0.433057,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_175"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_175",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_175"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.8066,
    y: 17.233,
    width: 32.2,
    height: 32.2,
    rx: 16.1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJto);
export default __webpack_public_path__ + "static/media/jto.582e72a76935e7b6f727f3ecf95c00fb.svg";
export { ForwardRef as ReactComponent };